import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default function SortHeader(props) {
  const [direction, setDirection] = useState(props.sortDirection || "asc");

  useEffect(() => {
    setDirection(props.sortDirection || "asc");
  }, [props.sortDirection])

  const callBackDir = direction === "desc"
    ? "asc"
    : "desc";

  if (props.textOnly) {
    return(
        <span>{props.displayName}</span>
      );
  } else {
    return (
      <span
        className="sort-handle"
        onClick={() => props.state ? props.callback(props.state) : props.callback(props.field, callBackDir)}
      >
        {props.displayName}
        {props.sorted && direction === "asc" && <FontAwesomeIcon icon="angle-up" className="ms-1" />}
        {props.sorted && direction === "desc" && <FontAwesomeIcon icon="angle-down" className="ms-1" />}
      </span>
    );
  }
}